/**
 * Returns unread message count for tab badge.
 * Wired to real Supabase data via useUnreadTotal from use-conversations.
 */
import { useUnreadTotal } from './use-conversations'

export function useUnreadCount(): number {
  return useUnreadTotal()
}
